export function isBadgeColorConfig(appearance) {
  return typeof appearance === "object" && "light" in appearance;
}